import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import EventCardStyles from '@stories/Components/Cards/EventCard/EventCard.styles';
import styled from 'styled-components';
const ItemList = styled.div `
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(12, 1fr);
  margin-top: var(--sectionMargin);

  @media ${from(Device.Tablet)} {
    gap: 30px;
  }
`;
const Item = styled.div `
  grid-column: span 6;

  /* @media ${from(Device.Tablet)} {
    grid-column: span 6;
  } */

  @media ${from(Device.TabletLarge)} {
    grid-column: span 4;
  }

  @media ${from(Device.Desktop)} {
    grid-column: span 3;
  }

  .theme-hta & {
    ${EventCardStyles.Container}[data-featured='true'] {
      ${EventCardStyles.Badge} {
        margin-bottom: 19px;
      }

      ${EventCardStyles.Tag} {
        margin-bottom: 9px;
      }

      ${EventCardStyles.Title} {
        ${fonts.sourceSansPro.semiBold};
        font-size: 18px;
        line-height: 24px;
        margin-bottom: 16px;

        @media ${from(Device.Tablet)} {
          font-size: 22px;
          line-height: 32px;
        }

        @media ${from(Device.Desktop)} {
          font-size: 25px;
          line-height: 35px;
        }

        @media ${from(Device.DesktopLarge)} {
          font-size: 30px;
          line-height: 38px;
        }
      }
      
    }
  }
`;
export default {
    Item,
    ItemList,
};
